import React from 'react'
import "./Error404.css"
const Error404 = () => {
    return (
        <div>
            404 not found
        </div>
    )
}

export default Error404
